class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) => {
      summary.addEventListener('click', this.onSummaryClick.bind(this));
    });
  }

  onKeyUp(event) {
    if (event.code !== 'Escape') return;
    this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
  }

  onSummaryClick(event) {
    const summary = event.currentTarget;
    const details = summary.parentNode;
    const isOpen = details.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const onAnimationEnd = (evt) => {
      details.classList.remove('menu-opening', 'menu-closing');
      summary.setAttribute('aria-expanded', details.hasAttribute('open'));
      if (evt.target.classList.contains('drawer__overlay')) {
        details.removeAttribute('open');
      }
    };

    setTimeout(() => {
      details.classList.add(isOpen ? 'menu-closing' : 'menu-opening');
      details.addEventListener('animationend', onAnimationEnd, { once: true });
    });
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.closeMenuDrawer();
      }
    });
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (!this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.classList.add('menu-closing');
    this.mainDetailsToggle.addEventListener(
      'animationend',
      () => {
        this.mainDetailsToggle.classList.remove('menu-closing', 'menu-opening');
        this.mainDetailsToggle.removeAttribute('open');
        if (elementToFocus) elementToFocus.focus();
      },
      { once: true }
    );
  }
}

customElements.define('menu-drawer', MenuDrawer);
